import FullWidthLayout from "@/layouts/FullWidthLayout";
import KDriverTimeOffTable from "kinnect-front/KYard/Drivers/KDriverTimeOffTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";
import { getDriversTimesOff } from "@/utils/http-calls";

export default {
	name: "YardDriversTimeOffPage",

	metaInfo: { title: "Yard - Drivers - Time Off" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		timesOff: [],
		search: ""
	} ),

	methods: {
		async fetchTimesOff() {
			this.timesOff = await getDriversTimesOff();
		},

		async fetch() {
			await this.fetchTimesOff();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<KDriverTimeOffTable
					items={this.timesOff}
					loading={this.$wait.is( "getDriversTimesOff" )}
					search={this.search}
				></KDriverTimeOffTable>
			</VCard>
		</FullWidthLayout>;
	}
};
